import { MECH_UPGRADES, SLOTS, mechUpById, mechUpMax } from '../data/mech-upgrades';
import { RNG } from '../core/rng';
import { recalcStats, registerModSource } from './stats';
/* ============================================================
   機體武裝強化的持有狀態（Boss 擊破獎勵）
   ============================================================

   資料與設計依據在 `data/mech-upgrades.ts`。這裡只管三件事：
   誰現在幾級、能不能再升、以及把修正丟進 `sim/stats.ts` 的修正層。

   **等級不放 `P` 上而放這裡**，跟 `weapons`／`passives` 同一個形狀：
   它們是「這一場的持有狀態」，重置的責任集中在 `resetLoadout()` 一個地方，
   少一個「新欄位忘了在 startRun 歸零」的坑（那個坑這個專案記過三次）。

   走修正層而不是直接改 `P.s`：同一條線升到 4 級不是「把當下的值再乘一次」，
   而且升級介面要能顯示「原始值 → 加成後」。理由完整版見 `sim/stats.ts` 檔頭。 */

/** id → 等級。查詢一律走 `mechUpLevel`，走訪一律照 `MECH_UPGRADES` 的順序
    （物件的 key 順序不該拿來當對局決定性的依據）。 */
var levels: Record<string, number> = {};

export function resetMechUps() {
  levels = {};
  recalcStats();
}

export function mechUpLevel(id) { return levels[id] || 0; }

/** 還升得動嗎。**不看槽位** —— 機體三把不佔槽（使用者 2026-08-03 拍板）。 */
export function canTakeMechUp(id) {
  var u = mechUpById(id);
  return !!u && mechUpLevel(id) < mechUpMax(u);
}

/** 升一級，回傳升到第幾級（0 = 沒成功）。 */
export function takeMechUp(id) {
  if (!canTakeMechUp(id)) return 0;
  levels[id] = mechUpLevel(id) + 1;
  recalcStats();
  return levels[id];
}

/** 這一次要發哪三張（使用者拍板的發牌規則）：
    **每把武器保證出一張**，同一把的兩種走向（威力／節奏）之間隨機挑。

    保證覆蓋的理由：玩家永遠選得到「這次要餵哪一把」——
    純隨機抽三張會出現「三張都是主武裝」或「想要的那把沒出現」，
    而這個獎勵一場只有幾次，被運氣吃掉一次的代價太大。
    隨機的是走向，所以每一場拿到的組合仍然不同。

    兩種走向都滿級的槽位會整個消失（一場拿不到那麼多，但沒有這道濾網的話
    「全滿之後還發一張沒用的卡」會是靜默的錯）。

    **一定要用種子 RNG**：這是對局的一部分，`Math.random` 會讓同一顆種子
    跑出不同的一場（`tools/lint-sim.js` 也會擋）。 */
export function mechUpIds() {
  var out: string[] = [];
  for (var s = 0; s < SLOTS.length; s++) {
    var cands: string[] = [];
    for (var i = 0; i < MECH_UPGRADES.length; i++) {
      var u = MECH_UPGRADES[i];
      if (u.slot === SLOTS[s] && canTakeMechUp(u.id)) cands.push(u.id);
    }
    if (!cands.length) continue;
    var k = cands.length === 1 ? 0 : Math.floor(RNG.next() * cands.length) % cands.length;
    out.push(cands[k]);
  }
  return out;
}

/** 給快照用。併進 `loadoutDigest()` —— 不併的話「同種子兩場的機體強化不同」
    對決定性測試是隱形的（黃金雜湊只看得到它被餵進去的東西）。 */
export function mechUpDigest() {
  var s = '';
  for (var i = 0; i < MECH_UPGRADES.length; i++) {
    var id = MECH_UPGRADES[i].id;
    if (levels[id]) s += id + levels[id] + ',';
  }
  return s;
}

/* 修正丟進數值層。註冊一次，之後只要 recalcStats。 */
registerModSource(function () {
  var out: any[] = [];
  for (var i = 0; i < MECH_UPGRADES.length; i++) {
    var u = MECH_UPGRADES[i], lv = levels[u.id] || 0;
    if (lv > 0) out.push(u.mods(lv));
  }
  return out;
});
